import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useDidYouMeanZeroResultSearchesExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.DidYouMeanZeroResultSearches,
        AmplitudeVariants.DidYouMeanZeroResultSearches.Treatment
    );
